export enum CsvTypes {
  FLAT_FILE = 'flat-file',
  CONTROL_POINT = 'control-point',
}
